import { packageId } from '@shared/matrix/const';
import { SSK } from '@shared/utils/storage/config';

export const inFacebookWebview = () => navigator.userAgent.match(/FBAN|FBAV/i);
export const resetDocumentTitle = () => {
	// @ts-expect-error 这个属性是在index.html中注入的
	if (window.defaultTitle) {
		// @ts-expect-error 这个属性是在index.html中注入的
		document.title = window.defaultTitle;
	}
};

/** 判断当前url是否为app详情页 */
export const isAppDetailPage = () => {
	const url = window.location.pathname;
	// 首先需要判断该url 之后一个 / 后 的字符为4位，例如/yun2，且url 中不包含 /i/
	return /\/[a-zA-Z0-9]{4}$/.test(url) && !/\/i\//.test(url);
};

/** 判断url是否为app详情页 */
export const isAppDetailPageByUrl = (url: string) => {
	// 首先需要判断该url 之后一个 / 后 的字符为4位，例如/yun2，且url 中不包含 /i/
	return /\/[a-zA-Z0-9]{4}$/.test(url) && !/\/i\//.test(url);
};

/** 判断url是否为post详情页 */
export const isPostDetailPageByUrl = (url: string) => {
	// 首先需要判断该url 之后一个 /post/ 后 的字符为6位，例如/post/asyun2
	return /\/post\/[a-zA-Z0-9]{6}$/.test(url);
};

/** 判断当前url是否为创建页 */
export const isBuildPage = () => {
	const url = window.location.pathname;
	return url.includes('build') || url.includes('remix');
};

/** 判断当前url是否为remix页*/
export const isRemixPage = () => {
	const url = window.location.pathname;
	return url.includes('remix');
};

export const getFeedbackUrl = (userId = '') => {
	// const userId = useUserCreate.getState().userState?.userId || '';
	const url = `https://docs.google.com/forms/d/e/1FAIpQLScbqa3OeiWJL717U1iDGVr4CP6xmHlg9h28qZl_kkBOwTjEeg/viewform?usp=pp_url&entry.971093492=${userId}`;
	return url;
};

export const extractBaseUrl = (url: string) => {
	const match = url.match(/^https?:\/\/([^?]+)/);
	return match ? match[1] : null;
};

export const getShareAppLink = (_url?: string | null) => {
	const url = extractBaseUrl(window.location.href);
	const searchParams = new URLSearchParams(window.location.search);
	const shareInfo = searchParams.get('share_token') || '';
	return `intent://${_url || url}#Intent;scheme=https;package=${packageId};S.browser_fallback_url=https://play.google.com/store/apps/details?id=${packageId}&referrer=utm_source%3Dshare,share_info%3D${shareInfo};end`;
};

/**@deprecated 使用 getH5DeepLink 替代 */
export const getAppLinkForAllPage = (_url?: string | null) => {
	// 吊起客户端等
	// const url = extractBaseUrl("https://a1.art");
	const url = extractBaseUrl(window.location.href);
	// const url = "a1.art";
	// 当前吊起app页url
	const open_url = window?.location?.href;
	// 来源页
	const entrance_url = sessionStorage.getItem(SSK.REFER_URL_BLOG) || document.referrer;
	return `intent://${_url || url}#Intent;scheme=https;package=${packageId};S.browser_fallback_url=https://play.google.com/store/apps/details?id=${packageId}&referrer=utm_source%3Dh5,open_url%3D${open_url},entrance_url%3D${entrance_url};end`;
};
